import curry from "./curry.js";

export default curry(function add(a, b) {
  return a + b;
});
